import crossFetch from 'cross-fetch';

export const getGqlEndpoint = () => {
  const EXTERNAL_MARKETPLACES = ['limango'];

  if (process.env.GQL_ENDPOINT) {
    return process.env.GQL_ENDPOINT;
  }

  if (EXTERNAL_MARKETPLACES.some(marketplace => window.location.pathname.includes(marketplace))) {
    return '/graphql-external-marketplace';
  }

  return '/graphql';
};

const fetch = async (...args: [RequestInfo, RequestInit?]) => {
  const res = await crossFetch(...args);
  if (res.ok) {
    return res;
  } else {
    // TODO: Refactor error handling for fetch. Currently it return an instance of the Error object
    // For this reason, we can compare only error message. We should return define clear interface
    // for error handlin.
    const error = new Error(res.statusText) as Error & {
      response: Response;
    };
    error.response = res;
    throw error;
  }
};

export default fetch;

export const fetchAndParse = async <ResponseData>(...args: [RequestInfo, RequestInit?]) => {
  const response = await fetch(...args);

  return response.json() as Promise<ResponseData>;
};
